/* eslint-disable */
const variable_url = `REACT_APP_API_URL_DEVELOPMENT`;
const variable_ums_url = `REACT_APP_UMS_API_URL`;
const variable_catalog_url='REACT_APP_CATALOGUING_SERVICE_URL'
const variable_po_url='REACT_APP_PO_SERVICE_BASE_URL';
const variable_kaagaz_url='REACT_APP_KAAGAZ_URL_PREFIX';
const variable_rmintegration_url='REACT_APP_RMINTEGRATION_URL_PREFIX';
const variable_inventory_url='REACT_APP_INVENTORY_BASE_URL';
const variable_ticketing_url = 'REACT_APP_TICKETING_URL';
const variable_ticket_listing_url = 'REACT_APP_TICKET_LISTING_URL';
const variable_ticket_commenting_url = 'REACT_APP_TICKET_COMMENTING_URL';
const fds_url='REACT_APP_FRAUD_DETECTION_SERVICE_BASE_URL'
const ss_url ='REACT_APP_SCHEDULING_URL_PREFIX'
const fin_url = 'REACT_APP_FINANCE_BACKEND_URL'

export const FDS_URL=process.env[fds_url];
export const BASE_URL = process.env[variable_url];
export const BASE_UMS_URL = process.env[variable_ums_url];
export const BASE_CATALOG_URL = process.env[variable_catalog_url];
export const BASE_PO_URL = process.env[variable_po_url];
export const BASE_KAAGAZ_URL = process.env[variable_kaagaz_url];
export const BASE_RMINTEGRATION_URL = process.env[variable_rmintegration_url];
export const REACT_APP_INVENTORY_BASE_URL = process.env[variable_inventory_url];
export const BASE_FINANCE_URL =  process.env[fin_url];
export const GOOPS_URL = `https://goops.${process.env['REACT_APP_MICRO_FRONTEND_BASE_URL'].split('.').slice(-3).join('.')}`;

export const TICKETING_URL = process.env[variable_ticketing_url];
export const TICKET_LISTING_URL = process.env[variable_ticket_listing_url];
export const TICKET_COMMENTING_URL = process.env[variable_ticket_commenting_url];
export const SS_URL = process.env[ss_url]

const USER_ONBOARDING = 'user-onboarding/';
const COMPANIES_IDENTIFIER = 'companies-identifier/';
const USERS = 'users/';
export const PURCHASE_REQUEST_TAB_TITLE = "Purchase Request";

const URLS = {
  AUTH_VERIFY: 'auth-verify',
  CREATE_USER: 'create-user',
  REFRESH_JWT_TOKEN: 'refresh-auth-token',
  BILLING_ENTITIES: 'get-bizongo-billing-entities',
  FILTERED_RAW_MATERIAL:'filtered-raw-materials',
  RM_SELLERS:'rm-suppliers',
  INVENTORY_DASHBOARD:'v1/dashboard',
  PR_DEAL:'deal',
  PRESIGNED_URL : 'document/presigned-url/upload',
  RM_ADDRESSES:'procure-plus/addresses',
  IS_EMAIL_REGISTERED:'is-email-registered',
  IS_MOBILE_NUMBER_REGISTERED:'is-mobile-number-registered',
  UPDATA_NEW_USER: `${USER_ONBOARDING}update-new-user`,
  SAVE_COMPANY_DETAILS: `${USER_ONBOARDING}save-company-details`,
  FETCH_COMPANY_DETAILS: `${USER_ONBOARDING}fetch-company-details`,
  BILLING_DETAILS: `${USER_ONBOARDING}billing-details`,
  FETCH_COMPANY_DOCUMENTS: `${USER_ONBOARDING}fetch-company-documents`,
  DELETE_DOCUMENT: `${USER_ONBOARDING}delete-doc`,
  FILE_UPLOAD_STATUS: `${USER_ONBOARDING}file-upload-status`,
  SUBMIT_DOCUMENT: `${USER_ONBOARDING}submit-docs`,
  ONBOARDING_DOC_STATUS: `${USER_ONBOARDING}onboarding-docs-status`,
  SEARCH_IDENTIFIER: `${COMPANIES_IDENTIFIER}search-identifier`,
  RESET_PASSWORD: `${USERS}reset-password`,
  VALIDATE_RESET_PASSWORD_TOKEN: `${USERS}validate-forgot-password-link`,
  ONE_CLICK_SIGNUP: `${USERS}signup`,
  AUTHENTICATE_PURCHASE_REQUEST_CONFIRMATION: "purchase-requisition/accept/authenticate"
};

export default URLS;
